import type { ConsumerApiClient } from '../client';

export interface Order {
  id: string;
  orderNumber: string;
  status: string;
  recipientName: string;
  facilityName: string;
  totalCents: number;
  itemCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface OrderAdditionalAttribute {
  attributeLabel: string;
  attributeName: string;
  value: string;
}

export interface OrderItem {
  id: string;
  productType: string;
  productName: string;
  quantity: number;
  unitPriceCents: number;
  totalPriceCents: number;
  size?: string;
  finish?: string;
  thumbnailUrl?: string;
}

export interface TrackingInfo {
  carrier: string;
  trackingNumber: string;
  estimatedDelivery?: string;
  status: string;
}

export interface StatusHistoryEntry {
  status: string;
  timestamp: string;
  description: string;
}

export interface RejectedPhoto {
  id: string;
  reason: string;
  reasonCode: string;
}

export interface ScreeningSummary {
  overallStatus: 'approved' | 'partially_approved' | 'rejected';
  rejectedPhotos: RejectedPhoto[];
}

export interface OrderDetail extends Order {
  items: OrderItem[];
  paymentMethod: string;
  subtotalCents: number;
  taxCents: number;
  discountCents: number;
  tracking?: TrackingInfo;
  statusHistory: StatusHistoryEntry[];
  additionalAttributes?: OrderAdditionalAttribute[];
  screening?: ScreeningSummary;
}

export interface OrdersApi {
  getOrders(page?: number): Promise<{ orders: Order[]; total: number }>;
  getOrder(id: string): Promise<OrderDetail>;
  getOrderByNumber(orderNumber: string): Promise<OrderDetail>;
  reorder(orderId: string): Promise<{ cartId: string }>;
}

export function createOrdersApi(client: ConsumerApiClient): OrdersApi {
  return {
    getOrders(page = 1) {
      return client.get(`/orders?page=${page}`);
    },
    getOrder(id) {
      return client.get(`/orders/${id}`);
    },
    getOrderByNumber(orderNumber) {
      return client.get(`/orders/number/${orderNumber}`);
    },
    reorder(orderId) {
      return client.post(`/orders/${orderId}/reorder`);
    },
  };
}
